var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "govgr-width-container" }, [
    _c("div", { staticClass: "govgr-main-wrapper" }, [
      _c("main", { staticClass: "govgr-grid-column-two-thirds" }, [
        _c("h1", { staticClass: "govgr-heading-xl" }, [
          _vm._v("Είσοδος Υπαλλήλων ΔΟΑΤΑΠ")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "govgr-body" }, [
          _vm._v("Για να συνεχίσετε πρέπει να συνδεθείτε.")
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "govgr-btn govgr-btn-primary govgr-btn-cta",
            on: {
              click: function($event) {
                _vm.employEntry()
              }
            }
          },
          [
            _vm._v("\n           Σύνδεση\n           "),
            _c(
              "svg",
              {
                staticClass: "govgr-arrow--right",
                attrs: {
                  viewBox: "0 0 24 24",
                  focusable: "false",
                  "aria-hidden": "true"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d: "M8.5,2L6.1,4.3l7.6,7.7l-7.6,7.6L8.5,22l10-10L8.5,2z"
                  }
                })
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ad362fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad362fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = null
// module chunks = 